import { render, staticRenderFns } from "./ViewProctorTestDetails.vue?vue&type=template&id=f46a6b20"
import script from "./ViewProctorTestDetails.vue?vue&type=script&lang=js"
export * from "./ViewProctorTestDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewProctorTestDetails.vue?vue&type=style&index=0&id=f46a6b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports